import { gql } from "@apollo/client";

export const QUERY_TRUCK_DETAIL = gql`
  query Truck($id: ID!) {
    truck(id: $id) {
      modfied
      id
      originAddress
      originCity
      destinationCity
      destinationAddress
      originIso2
      originCountry
      destinationCountry
      originIso3
      destinationIso2
      destinationIso3
      originZip
      originAreacode
      destinationZip
      destinationAreacode
      originRadius
      destinationRadius
      areaCode
      targetRate
      length
      weight
      timeEnd
      timeStart
      matchDate
      details
      notificationPush
      notificationEmail
      matches
      linehaulDistance
      duration
      isDeleted
      originCoords {
        latitude
        longitude
      }
      destinationCoords {
        latitude
        longitude
      }
      timePosted
      user {
        id
        email
        userType
        dba
        contactName
        contactEmail
        city
        state
        country
        contactPhone
        mc
        dot
        hasVerifiedEmail
      }
      trailerTypes {
        id
        loadtypes
        loadChoiceFull
      }
      originRegion {
        id
        originStates
        destinationStates
      }
      destinationRegion {
        id
        originStates
        destinationStates
      }
      averageRating
    }
  }
`;

export const QUERY_TRUCK_QUESTION = gql`
  query TruckQuestions($truckId: UUID!) {
    truckQuestions(truckId: $truckId) {
      data {
        timePosted
        id
        question
        user
        rawId
        truckId
        answerSet {
          timePosted
          id
          answer
        }
      }
    }
  }
`;

export const MUTATION_CREATE_TRUCK_QUESTION = gql`
  mutation CreateQuestion($question: String!, $truckId: UUID!) {
    createQuestion(question: $question, truckId: $truckId) {
      question {
        timePosted
        id
        question
        user
      }
    }
  }
`;

export const MUTATION_CREATE_TRUCK_ANSWER = gql`
  mutation CreateAnswer($answer: String!, $questionId: String!, $truckId: String!) {
    createAnswer(answer: $answer, questionId: $questionId, truckId: $truckId) {
      answer {
        timePosted
        id
        answer
        truckId
        questionId
      }
    }
  }
`;

export const MUTATION_SAVE_TRUCK = gql`
  mutation CreateUserSavedTruck($truckId: UUID!) {
    createUserSavedTruck(truckId: $truckId) {
      userSavedTruck {
        id
        originCity
        destinationCity
        originCountry
        destinationCountry
        originZip
        destinationRadius
        originRadius
        destinationZip
        length
        weight
        timeStart
        timeEnd
        details
        linehaulDistance
        duration
        timePosted
        userId
        targetRate
        isDeleted
      }
    }
  }
`;
